import seoFragment from "./seo";

export const collectionFragment = /* GraphQL */ `
  fragment collection on Collection {
    handle
    title
    description
    seo { ...seo }
    updatedAt
  }
  ${seoFragment}
`;


